export default "__VITE_ASSET__Do8euPFR__"